import AddNewBoard from "./AddNewBoard.jsx";

export default AddNewBoard;
